import { type FormProps, Modal } from 'antd'
import React from 'react'

import { type BundleCreateParams, BundleService } from '@services/BundleService'
import { useNotifications } from '@store/notifications'

import type { Curriculum } from '../../../../types'
import { type BundleFieldType, BundleForm } from '../components/BundleForm'

type ModalProps = {
    isOpen: boolean
    onClose: () => void
    onSuccess: () => void
    curriculums?: Curriculum[]
}

export const CreateBundleModal: React.FC<ModalProps> = ({ isOpen, onClose, onSuccess, curriculums }) => {
    const { showNotification } = useNotifications()

    const onFinish: FormProps<BundleFieldType>['onFinish'] = async values => {
        const body: BundleCreateParams = {
            name: values.name,
            description: values.description,
            order: values.order,
            bundleCurriculums: values.curriculumIds.map(curriculumId => ({ curriculumId })),
            creatorId: values.creatorId,
            version: 1
        }

        if (values.meta?.links) {
            body.meta = { links: values.meta.links }
        }

        try {
            await BundleService.create(body)
            showNotification({ title: 'Bundle created successfully' })
            onSuccess()
            onClose()
        } catch (err: any) {
            showNotification({ title: 'Bundle created failed', type: 'error', description: err.toString() })
        }
    }

    return (
        <Modal open={isOpen} footer={[]} onCancel={onClose}>
            <BundleForm title="Create New Bundle" onFinish={onFinish} onCancel={onClose} curriculums={curriculums} />
        </Modal>
    )
}
